// scss
import './src/styles/style.scss';

import { ActionContextProvider, createConfig } from './src/cra';

import { Helmet } from 'react-helmet';
import React from 'react';
import { posthog } from 'posthog-js';

export const onClientEntry = () => {
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const distinctId = hashParams.get('distinct_id');
  const sessionId = hashParams.get('session_id');

  posthog.init(process.env.GATSBY_POSTHOG_API_KEY, {
    api_host: process.env.GATSBY_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    ...(distinctId && sessionId
      ? { bootstrap: { distinctID: distinctId, sessionID: sessionId } }
      : {}),
  });
};

export const onRouteUpdate = () => {
  posthog.capture('$pageview');
};

export const wrapRootElement = ({ element }) => {
  createConfig({
    website: 'Medicare FAQ',
  });
  return (
    <ActionContextProvider>
      <Helmet>
        <script
          async
          defer
          id='demio-js'
          type='text/javascript'
          src='https://cdn.demio.com/production/dashboard/embed.bundle.js'
        ></script>
      </Helmet>
      {element}
    </ActionContextProvider>
  );
};
